import React, { useState } from 'react';
import { FaCheckCircle } from 'react-icons/fa';
import '../styles/ModalConfirm.css';
import CommonButton from './CommonButton';
import MessageModal from './MessageModal';

const ModalConfirm = ({
  title,
  message,
  showTextBox,
  onClickYes,
  onClickNo,
  error,
  isResponseModal,
  responseTitle,
  responseMessage,
  onResponseClose,
  isLoading = false,
}) => {
  const [reason, setReason] = useState('');

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>{title}</h3>
        <p>{message}</p>

        {showTextBox && (
          <textarea
            placeholder="Blockir reason..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            disabled={isLoading}
          />
        )}

        <div>
          <CommonButton
            className="confirm-block-button"
            onClick={() => onClickYes(reason)}
            loading={isLoading}              // ✅ loading
          >
            Yes
          </CommonButton>

          <CommonButton
            className="confirm-block-button"
            onClick={onClickNo}
            isCancel={true}
            disabled={isLoading}             // ✅ lock No
          >
            No
          </CommonButton>
        </div>

        {isResponseModal && (
          <MessageModal 
            onClose={onResponseClose}
            title={responseTitle}
            message_content={responseMessage}  
            icon={<FaCheckCircle/>}
            button_name="Close"
            isSuccess={error === ''}
          />
        )}
      </div>
    </div>
  );
};

export default ModalConfirm;
